import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { prepratationVaporTabs } from "@app/pages/samples/utils/constants";
import { useTabsPreparation } from "./utils/useTabPreparation";

const PreparationVapor = () => {
  const { currentPreparation } = useAnalysis();

  const { tabValue, setTabValue } = useTabsPreparation();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const ComponentePreparacion = prepratationVaporTabs[tabValue].component;

  return (
    <>
      {currentPreparation.index !== undefined && (
        <>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="Fields prepraration vapor tabs"
            sx={{ margin: 0 }}
          >
            {prepratationVaporTabs.map((set, index) => (
              <Tab key={index} label={set.label} />
            ))}
          </Tabs>
          <ComponentePreparacion key={currentPreparation.index} />
        </>
      )}
    </>
  );
};

export default PreparationVapor;
